import React, { useState } from 'react';

import type { ReportList } from 'api/endPoints/getReportList';
import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { MenuGroupItems } from 'components/common/reportingSideMenu/components/MenuGroupItems/MenuGroupItems';
import classes from 'components/common/reportingSideMenu/components/menuGroup/MenuGroup.module.scss';

interface Props {
    items: ReportList[];
    handleItemClick: (item: ReportList) => void;
    groupName: string;
    groupId: number;
    selectedItemId: string;
    filterCondition?: (item: ReportList) => boolean;
    isDeletable?: boolean;
    onDelete?: (tag: Tag) => void;
    groupIcon?: React.ReactNode;
}

export const MenuGroup = ({
    items,
    handleItemClick,
    groupName,
    groupId,
    selectedItemId,
    isDeletable = false,
    onDelete,
    filterCondition,
    groupIcon,
}: Props) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    const filteredReportsByGroup = filterCondition ? items.filter(filterCondition) : items;

    return (
        <div className={classes.menuGroup}>
            <div className={classes.groupNameWrapper} onClick={toggleExpanded}>
                {groupIcon && groupIcon}
                <h2 className={classes.groupName}>{groupName}</h2>
                {isDeletable && onDelete && (
                    <MuiIcon
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete({
                                id: groupId,
                                name: groupName,
                            });
                        }}
                        className={classes.deleteIcon}
                        icon={'delete'}
                        fontSize={'2rem'}
                        type={'outlined'}
                    />
                )}
                {isExpanded ? (
                    <MuiIcon icon={'expand_less_icon'} className={classes.arrowIcon} />
                ) : (
                    <MuiIcon icon={'expand_more_icon'} className={classes.arrowIcon} />
                )}
            </div>

            {isExpanded && filteredReportsByGroup.length > 0 && (
                <MenuGroupItems
                    items={filteredReportsByGroup}
                    selectedItemId={selectedItemId}
                    handleItemClick={handleItemClick}
                />
            )}
        </div>
    );
};
